import { Injectable, Inject, SkipSelf } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvironmentModel } from './models/environment.model';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { Product } from './models/product.model';

export let countryCode;
export let currencyCode;
export let currencySymbol;
export let price;
export let metaTag;
export let basic_configure;
declare let FontFace: any;
  function _window(): any {
  // return the global native browser window object
  return window;
}
@Injectable({
  providedIn: 'root'
})
export class CommonLibService {
 private recentProductTransmitter = new Subject<any>()
 recentProduct = this.recentProductTransmitter.asObservable();
 alsoLikeProductTransmitter = new Subject();
 firstTimeCouponTransmitter = new Subject();
 invokeEvent: Subject<any> = new Subject();
 loginInformation;
 private productCount = new Subject<any>();
 private triggerHandler = new Subject<any>();
  loadAPI: Promise<any>;
  seesionCountry: string;
 websiteStorage: Storage = localStorage;
  public sortTransmitter = new Subject<any>();
  constructor( private http: HttpClient, @Inject('environment') private env: EnvironmentModel, private title: Title, private metaService: Meta, @Inject(DOCUMENT) private dom) { }
  
  setTrigger(page) {
    this.triggerHandler.next({page: page});
  }
  identifyTrigger(): Observable<any> {
    return this.triggerHandler.asObservable();
  }
  getRecent(recent) {
    this.recentProductTransmitter.next(recent);
  }
  setRecent(recent): void {
    this.recentProductTransmitter.next(recent);
  }
  getSub() {
    return this.recentProductTransmitter.asObservable();
  }
  getPager(totalItems: number, currentPage: number = 1, pageSize: number = 30) {
    let totalPages = Math.ceil(totalItems / pageSize);
  
    if (currentPage < 1) {
      currentPage = 1;
    } else if (currentPage > totalPages) {
      currentPage = totalPages;
    }
  
    let startPage: number, endPage: number;
    if (totalPages <= 5) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage + 2 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } else {
        startPage = currentPage - 3;
        endPage = currentPage + 2;
      }
    }
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
    let pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    };
  }
  
retrivePinCodeApi(pincode) {

  const url: string = `${'https://api.postalpincode.in/pincode/'}` + pincode;
  return this.http.get<any>(url);
}
  callMethod() {
    return this.invokeEvent.next(true);
  }
  
  getSettings(): Promise<any> {
    const url = this.env.productServiceUrl + 'getcountrywiseprice';
    const promise = this.http.get(url)
      .toPromise()
      .then((settings: any) => {
        if (settings.find(a => a.countryCode === this.seesionCountry)) {
          const selectedList = settings.find(a => a.countryCode === this.seesionCountry);
          countryCode = selectedList.countryCode;
          currencyCode = selectedList.currencyCode;
          sessionStorage.setItem('currencycode', currencyCode);
          currencySymbol = selectedList.currencySymbol;
          price = selectedList.amount;
        } else if (settings.find(a => a.countryCode === 'IN')) {
          const selectedList = settings.find(a => a.countryCode === 'IN');
          countryCode = selectedList.countryCode;
          currencyCode = selectedList.currencyCode;
          sessionStorage.setItem('currencycode', currencyCode);
          currencySymbol = selectedList.currencySymbol;
          price = selectedList.amount || 1;
        } else {
          countryCode = 'IN';
          currencyCode = 'INR';
          sessionStorage.setItem('currencycode', currencyCode);
          currencySymbol =  '₹';
          price =  1;
        }
        this.loadScript();
      });
    return promise
  }
  

  public loadScript() {        
    var isFound = false;
    var scripts = document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
        if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("loader")) {
            isFound = true;
        }
    }
    
    if (!isFound) {
        var currency = sessionStorage.getItem('currencycode'); 
        /* var dynamicScripts = ["https://www.paypal.com/sdk/js?client-id=AdWh_oXTFDCyTbpfMoCnekAGbqdsKjfNHZuGGU_Z1fz1lLHSuZ1C35nMaPHS6vYWZK_-Gl5TfjkyqZDh&currency="+currency+"&intent=capture&commit=false&vault=true"]; */
        var dynamicScripts = ["https://www.paypal.com/sdk/js?client-id=AZUkLhiaUizj0r-zGM-tp9EFDRNrDW_XZjMnFHpfH_YuE_mjvlaQ1Hdi80JcykuFRadz9ifeJukZy3ca&currency=" + currency + "&intent=capture&commit=false&vault=true"];
        for (var i = 0; i < dynamicScripts.length; i++) {
            let node = document.createElement('script');
            node.src = dynamicScripts [i];
            node.type = 'text/javascript';
            node.async = false;
            node.charset = 'utf-8';
            document.getElementsByTagName('head')[0].appendChild(node);
        }
    }
  }
  getMetaTag(): Promise<any> {
    const url = this.env.productServiceUrl + 'findmetatagshome';
    const promise = this.http.get(url).toPromise().then(tag => {
      metaTag = tag
    });
    return promise;
  }
  getBasicConfgure(): Promise<any> {
    const url = this.env.commerceOrderServiceUrl + 'getallconfiguredetails';
    const promise = this.http.get(url).toPromise().then(detail => {
      if (Array.isArray(detail) && detail.length !== 0) {
        basic_configure = detail[0];
        if (basic_configure && basic_configure.custom_font) {
          this.setFontFamily(basic_configure.custom_font);
        }
      }
    })
    
    return promise;
  }
  get nativeWindow(): any {
    return _window();
 }

addTitle(title) {
  this.title.setTitle(title);
}
addMegaTag(tags) {
  tags.forEach(tag => this.metaService.updateTag(tag))
}
setCanonicalURL(url?: string) {
  const canURL = url == undefined ? this.dom.URL : url;
  const link: HTMLLinkElement = this.dom.createElement('link');
  link.setAttribute('rel', 'canonical');
  this.dom.head.appendChild(link);
  link.setAttribute('href', canURL);
}
setFontFamily(font) {
  let customeFont = new FontFace('custom-font', `url(${font})`);
  customeFont.load().then(res => {
    this.dom['fonts'].add(res);
  }).catch((error) => {
    console.log(error);
  }) 
}
hyphenateUrlParams(productModel) {
  productModel.forEach(element => {
    element.link = element.productName.replace(/[^a-zA-Z ]/g, "").replace(/\s+/g, '-').toLowerCase()
  });
  return productModel
}
routeFieldAccess(field) {
 switch(field) {
   case 'fbclid':
     return false;
   case 'gclid':
     return false;
   case 'utm_source':
     return false;
   case 'utm_medium':
     return false;
   case 'utm_campaign': 
     return false;
   default:
     return true;
 }
}
mergeArray(array) {
  return array.reduce((prev, next) => {
    return prev.concat(Array.isArray(next) ? this.mergeArray(next) : next)
  }, [])
}
getQueryParams(product: Product) {
  if (product.variationType !== 'None' && product.totalQuantity.length == 1 && product.totalQuantity.reduce((total, quantity) => total + quantity, 0) >= 1 ) {
    return {cid: product.childId}
  } else {
  return null
}
}
setProductCount(count: number) {
  this.productCount.next({productCount: count});
}
getProductCount(): Observable<any> {
  return this.productCount.asObservable();
}

/* Login */

checkLogin(): boolean {
  return JSON.parse(this.websiteStorage.getItem('login'));
}
getUserId(): string {
  return this.websiteStorage.getItem('userId');
}
loginOut() {
  this.websiteStorage.removeItem('emailId');
  this.websiteStorage.removeItem('cartcount');
  this.websiteStorage.removeItem('lastLoginBy');
  this.websiteStorage.removeItem('token');
  this.removeUserId();
  this.removeWallet();
  this.setLoginStatus('false');
  this.setWishlistCount();
  this.removeCoupon();
}
setLoginStatus(status: string) {
  this.websiteStorage.setItem('login', status);
}
setLogin(lastLoginBy: string = 'registered', emailId: string, userId: string, guestCustomer: boolean = false) {
  this.setLoginStatus('true');
  this.websiteStorage.setItem('lastLoginBy', lastLoginBy);
  this.websiteStorage.setItem('emailId', emailId);
  this.websiteStorage.setItem('userId', userId);
  this.websiteStorage.setItem('guestCustomer', JSON.stringify(guestCustomer));
}
removeUserId() {
  this.websiteStorage.removeItem('userId');
}
getLastLoginBy() {
  return this.websiteStorage.getItem('lastLoginBy');
}
getEmailId() {
  return this.websiteStorage.getItem('emailId');
}
setToken(token: string, guestCustomer: boolean = false) {
  this.setLoginStatus('true');
  this.websiteStorage.setItem('guestCustomer', JSON.stringify(guestCustomer))
  this.websiteStorage.setItem('token', token);
}
getToken(): string {
  return this.websiteStorage.getItem('token');
}
clearToken() {
  this.websiteStorage.removeItem('token');
  // this.setCartCount(0);
  // this.setLoginStatus('false');
  this.loginOut();
}
setLoginDetials(isLogin: boolean = false, userId: string = 'empty', email: string = 'empty', guestCustomer: boolean = false, lastLoginBy: string = 'empty') {
  let now = new Date();
  let expiry = now.getTime() + 6 * 3600 * 1000;
  let message = `${isLogin};${expiry};${userId};${email};${guestCustomer};${lastLoginBy}`;
  localStorage.setItem('lci', message);
}
getLoginDetail(field: string) {
let info = sessionStorage.getItem('lci');
if (!info) return false;
let infoArray = info.split(';');
if (!this.checkLoginExpiryDate(infoArray[1])) false;
switch(field) {
  case 'isLogin': 
   return infoArray[0];
  case 'userId':
   return infoArray[2];
  case 'email':
   return infoArray[3];
  case 'guestCustomer':
   return infoArray[4];
  case 'lastLoginBy':
   return infoArray[5];
  default:
   return false; 
}
}
checkLoginExpiryDate(expiryTime) {
let now = new Date();
if (now.getTime() > expiryTime) {
  localStorage.removeItem('lci');
  return false;
}
return true;
}


/* Wishlist */

setWishlistCount(count: number = 0) {
  this.websiteStorage.setItem('wishlistcount', JSON.stringify(count))
}
getWishlistCount() {
  return this.websiteStorage.getItem('wislistcount') || 0;
}

/* cart */


getLocalCart() {
  return JSON.parse(this.websiteStorage.getItem('cart')) || [];
}
setLocalCart(cart) {
  this.websiteStorage.setItem('cart', JSON.stringify(cart));
}
removeLocalCart() {
  this.websiteStorage.removeItem('cart');
}
setCartCount(count: number = 0) {
  this.websiteStorage.setItem('cartcount', JSON.stringify(count));
}
getCartCount() {
  return this.websiteStorage.getItem('cartcount') || 0
}

/* Wallet */

setWallet() {
  this.websiteStorage.setItem('wallet', 'true');
}
getWallet() {
  return this.websiteStorage.getItem('wallet');
}
removeWallet() {
  return this.websiteStorage.removeItem('wallet');
}

/* Gift Wrapping */

setGiftWrap(setting) {
  this.websiteStorage.setItem('gift', setting);
}
checkGiftWrap() {
  return JSON.parse(this.websiteStorage.getItem('gift'));
}
removeGiftWrap() {
  this.websiteStorage.removeItem('gift');
}

/* coupon  */

getCoupon() {
  return this.websiteStorage.getItem('coupon');
}
setCoupon(couponId: string) {
  this.websiteStorage.setItem('coupon', couponId);
}
removeCoupon() {
  this.websiteStorage.removeItem('coupon')
}
async checkToken() {
  const url: string = `${this.env.customerServiceUrl}verifytokendetails`;
  const token = await this.getToken();
  const header = new HttpHeaders().set('Authorization', token)
  return (this.http.get<any>(url, {headers: header})).toPromise();
}
}
